// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { plinga as _plinga } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the plinga chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 242
 * Chain Name: Plinga
 * Default Block Explorer: https://www.plgscan.com
 * Default RPC URL: https://rpcurl.mainnet.plgchain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { plinga } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: plinga,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const plinga = createCommon({
	..._plinga,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
